function initializeKeyVisual(){
  const keyVisualElement = document.querySelector("#js-keyVisual");
  if (keyVisualElement) {
    new Swiper("#js-keyVisual",{
      effect:"fade",
      fadeEffect:{crossFade:!0},
      loop:!0,
      loopAdditionalSlides:1,
      speed:2e3,
      autoplay:{delay:4e3,disableOnInteraction:!1,waitForTransition:!1},
      followFinger:!1,
      pagination:{el:"#js-keyVisual .swiper-pagination",clickable:!0}
    });
  }
}

window.addEventListener("load",function(){
  initializeKeyVisual(),
  initializeConcept(),
  initializeRanking(),
  initializePress(),
  initializeGlobalActivities()
});

const BREAK_POINT_MAX="(max-width: 767px)";

function initializeConcept(){
  const conceptSliderElement = document.querySelector("#js-conceptSlider");
  if (conceptSliderElement && window.matchMedia(BREAK_POINT_MAX).matches) {
    new Swiper("#js-conceptSlider",{
      slidesPerView:1.18,
      spaceBetween:27,
      navigation:{prevEl:"#js-conceptSlider .swiper-button-prev",nextEl:"#js-conceptSlider .swiper-button-next"}
    });
  }
}

function initializeRanking(){
  const rankingSliderElement = document.querySelector("#js-rankingSlider");
  if (rankingSliderElement) {
    new Swiper("#js-rankingSlider",{
      slidesPerView:1.18,
      spaceBetween:32,
      breakpoints:{768:{slidesPerView:3,slidesPerGroup:3,spaceBetween:36}},
      navigation:{prevEl:"#js-rankingSlider .swiper-button-prev",nextEl:"#js-rankingSlider .swiper-button-next"}
    });
  }
}

function initializePress(){
  const pressSliderElement = document.querySelector("#js-pressSlider");
  if (pressSliderElement) {
    new Swiper("#js-pressSlider",{
      slidesPerView:3.2,
      slidesPerGroup:3,
      spaceBetween:16,
      breakpoints:{768:{slidesPerView:5.8,slidesPerGroup:6,spaceBetween:32}},
      navigation:{prevEl:"#js-pressSlider .swiper-button-prev",nextEl:"#js-pressSlider .swiper-button-next"}
    });
  }
}

function initializeGlobalActivities(){
  const globalActivitiesSliderElement = document.querySelector("#js-global-activitiesSlider");
  if (globalActivitiesSliderElement) {
    new Swiper("#js-global-activitiesSlider",{
      slidesPerView:2.2,
      spaceBetween:16,
      breakpoints:{768:{slidesPerView:3,slidesPerGroup:3,spaceBetween:32}},
      navigation:{prevEl:"#js-global-activitiesSlider .swiper-button-prev",nextEl:"#js-global-activitiesSlider .swiper-button-next"}
    });
  }
}